import { ButtonGroup, Button, Modal } from '@veneer/core';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { sendFinishedEvent } from '../../../jarvis/eventService';
import { getProjectExpirationText } from '../../../helpers/expirationDate';

export type ModalExitProps = {
  projectId: string;
  expiresAt: string;
  isSavedProject: boolean;
  productCategory: string;
};

function ModalExit(props: ModalExitProps) {
  const [showModal, setShowModal] = useState(true);
  const history = useHistory();

  const expirationDate = getProjectExpirationText(props.expiresAt);

  const onClickOk = () => {
    console.log('Sending FinishedEvent');
    setShowModal(false);
    sendFinishedEvent();
  };

  const onClickCancel = () => {
    setShowModal(false);
    history.replace(`/designer?projectId=${props.projectId}&resume=false`);
  };

  return (
    <>
      <Modal
        id="regular-modal"
        show={showModal}
        title="Are you sure?"
        footer={
          <ButtonGroup>
            <Button onClick={onClickCancel}>No, go back</Button>
            <Button onClick={onClickOk} appearance="secondary">
              Yes, cancel
            </Button>
          </ButtonGroup>
        }
      >
        {props.isSavedProject ? (
          <p>
            You’re almost done! We’ve saved your custom {props.productCategory}. Come back within [{expirationDate}] to
            complete your project before your photos are removed.
          </p>
        ) : (
          <p>
            If you cancel, we won’t be able to send your {props.productCategory} and you will not be able to create a
            new one.
          </p>
        )}
      </Modal>
    </>
  );
}

export default ModalExit;
